export class ApiError extends Error {
  code: number;
  message: string;

  constructor(code: number, message: string) {
    super(message);
    this.code = code;
    this.message = message;
  }
}
export interface Pagination {
  currentPage: number;
  filteredPages: number | null;
  pageSize: number;
  processedCount: number;
  totalCount: number;
  totalPages: number;
}

export interface DocumentZipFilters {
  searchQuery?: string;
  processed?: boolean;
  extensions?: string[];
  startDate?: string;
  endDate?: string;
  documentTypes?: string[];
  documentThemes?: string[];
  hasKeyFacts?: boolean;
  hasRelevantFacts?: boolean;
}

export enum QueryEntity {
  ActiveRuns,
  AllActiveRuns,
  ApideckAllConnections,
  ApideckSession,
  AuditTrail,
  Case,
  DocChronologies,
  DocChronology,
  DuplicateScanStatus,
  DocChronologyDocs,
  SubsetDocsCount,
  SubsetDocs,
  SubsetFacts,
  SubsetFactAllIds,
  SubsetInconsistencies,
  SubsetPersons,
  Subset,
  Subsets,
  Chronologies,
  Chronology,
  ChronologyFacts,
  ChronologyVisualisation,
  Chunk,
  Doc,
  DocIds,
  FilteredDocIds,
  DocTypes,
  SubsetOverview,
  DocThemes,
  DocTotals,
  DocSubsetFacts,
  DocumentChunkMatches,
  Fact,
  FactDetails,
  FailedDocs,
  Files,
  InconsistenciesByIds,
  InconsistencyReport,
  InconsistencyReports,
  Matter,
  Matters,
  MatterOverview,
  MatterDocFilterValues,
  MatterDocsWithCases,
  MatterChronologies,
  MatterDocChronologies,
  Messages,
  Organisation,
  OrganisationById,
  Organisations,
  OrgUsageData,
  PendingInvites,
  ProcessingDocs,
  PresignedGetDocumentImage,
  PresignedGetDocumentPDF,
  RecentSubsets,
  GlobalRecentSubsets,
  RelativityDocumentCount,
  SubsetSuggestions,
  SubsetSuggestion,
  RelativityLists,
  RelativityWorkspaces,
  RelativityWorkspaceFields,
  RelativityFieldChoices,
  RelativityFieldMapping,
  MetadataFilterOptions,
  ConfiguredRelativityWorkspaces,
  RelativitySyncPreview,
  RelativitySyncStatus,
  Roles,
  Runs,
  Summary,
  CaseThemes,
  Threads,
  KimMessages,
  KimThreads,
  ThreadStatus,
  PublishedThreads,
  Transcript,
  TranscriptSubfact,
  Transcripts,
  UploadHistory,
  FileHistoryStats,
  SkippedFiles,
  DeletedFiles,
  ProcessedDocs,
  NotProcessedDocs,
  UserRoles,
  Users,
  User,
}
